import { render } from "./new-friends.vue?vue&type=template&id=fcfa0c6c"
import script from "./new-friends.vue?vue&type=script&lang=js"
export * from "./new-friends.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__